import HeroBanner from "../../components/goods/hero-banner";
import FlashSales from "../../components/goods/flash-sales";
import CategoryBrowser from "../../components/goods/catagory-browser";
import BestSelling from "../../components/goods/best-selling";
import AudioBanner from "../../components/goods/audio-banner";
import ExploreProducts from "../../components/goods/explore-products";
import NewArrivals from "../../components/goods/new-arrivals";
import ShippingInfo from "../../components/goods/shipping-info";
import Sidebar from "../../components/goods/sidebar";

export default function Home() {
  return (
    <div className="flex flex-col lg:flex-row">
      {/* <Sidebar className="hidden lg:block lg:w-64 shrink-0" /> */}
      <div className="flex-1 px-4 md:px-6 pb-12">
        <Sidebar />
        <HeroBanner />
        <FlashSales />
        <CategoryBrowser />
        <BestSelling />
        <AudioBanner />
        <ExploreProducts />
        <NewArrivals />
        <ShippingInfo />
      </div>
    </div>
  )
}

